const readHostCss = (host: Element | null, token: string, fallback: string): string => {
  if (!host) return fallback;
  const value = getComputedStyle(host).getPropertyValue(token).trim();

  return value || fallback;
};

const queryShadowAll = (selector: string, root: ParentNode = document): Element[] => {
  const results: Element[] = [];

  const traverse = (node: ParentNode): void => {
    node.querySelectorAll('*').forEach(el => {
      if (el.matches(selector)) results.push(el);
      if (el.shadowRoot) traverse(el.shadowRoot);
    });
  };

  traverse(root);

  return results;
};

const applyProductTilePriceStyles = (
  root: ParentNode = document,
  hostSelector = '.cx-agent-studio-messenger',
): void => {
  const host = document.querySelector(hostSelector);
  const saleColor = readHostCss(host, '--cx-agent-sale-price-color', '#d32f2f');
  const saleFontWeight = readHostCss(host, '--cx-agent-sale-price-font-weight', '500');
  const originalFontSize = readHostCss(host, '--cx-agent-original-price-font-size', '12px');
  const productPriceFontSize = readHostCss(host, '--cx-agent-product-price-font-size', '14px');
  const productLineHeight = readHostCss(host, '--cx-agent-product-price-line-height', '1.15');
  const originalLineHeight = readHostCss(host, '--cx-agent-original-price-line-height', '1.15');

  queryShadowAll('df-product-metadata', root).forEach(tile => {
    if (!(tile instanceof HTMLElement)) return;
    const shadow = tile.shadowRoot;
    if (!shadow || tile.dataset.cxAgentPriceStyled) return;
    const prominentPrice = shadow.querySelector('.price-large, .price-small');
    if (!(prominentPrice instanceof HTMLElement)) return;

    prominentPrice.style.fontSize = productPriceFontSize;
    prominentPrice.style.lineHeight = productLineHeight;

    const originalPrice = shadow.querySelector('.price-original');
    if (originalPrice instanceof HTMLElement) {
      originalPrice.style.fontSize = originalFontSize;
      originalPrice.style.lineHeight = originalLineHeight;
      prominentPrice.style.color = saleColor;
      prominentPrice.style.fontWeight = saleFontWeight;
    }

    tile.dataset.cxAgentPriceStyled = '1';
  });
};

export const setupProductCarouselSalePriceObserver = (): () => void => {
  let observer: MutationObserver | null = null;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const scheduleApply = (): void => {
    if (timeoutId !== null) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      applyProductTilePriceStyles();
    }, 100);
  };

  const onMessageListLoaded = (): void => {
    const [ msgList ] = queryShadowAll('chat-messenger-message-list');
    if (!msgList?.shadowRoot) return;
    scheduleApply();
    observer?.disconnect();
    observer = new MutationObserver(scheduleApply);
    observer.observe(msgList.shadowRoot, { childList: true, subtree: true });
  };

  window.addEventListener('chat-messenger-message-list-loaded', onMessageListLoaded);

  return (): void => {
    window.removeEventListener('chat-messenger-message-list-loaded', onMessageListLoaded);
    observer?.disconnect();
    observer = null;
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
};
